import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { BannersService } from 'src/app/services/banners.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form
} from '@angular/forms';

@Component({
  selector: 'app-banners',
  templateUrl: './banners.component.html',
  styleUrls: ['./banners.component.scss'],
  host: { 'class': 'wrapper-settings' }
})
export class BannersComponent implements OnInit {

  public banners: any[]
  public regions: any[]

  public loadingBanner: boolean = false
  public local: string = ''
  public local_slug: string = ''
  public title: string = ''

  public changed: boolean = false

  public bannerFrm: FormGroup

  public banner_tipo: FormControl
  public banner_intervalo: FormControl
  public banner_colunas: FormControl

  public allSelected: boolean = false
  public canDelete: boolean = false

  constructor(private _bannersService: BannersService, private _route: ActivatedRoute, private _router: Router) { }

  ngOnInit(): void {

    this.createFormControls()
    this.createForm()

    this.banners = []

    this.loadingBanner = true

    this.findRegions()

    /*
    this._route.params.subscribe(data => {
      if (data['local'] !== undefined) {
        this.local_slug = data['local']
        switch (this.local_slug) {
          case 'adicional':
            this.title = 'adicional'
            this.local = 'BA';
            break;
          case 'meio':
            this.title = 'meio'
            this.local = 'BM';
            break;
          case 'rodape':
            this.title = 'rodapé'
            this.local = 'BR';
            break;
          case 'lateral':
            this.title = 'lateral'
            this.local = 'BL';
            break;
          case 'internas':
            this.title = 'internas'
            this.local = 'BI';
            break;
          case 'popup':
            this.title = 'popUp'
            this.local = 'BP';
            break;
          default:
            this._router.navigate(['/app/configuracao/design'])
            break;
        }
        if (this.local) this.config(true)
      }
    })
    */
  }

  findRegions() {
    this._bannersService.showRegions().subscribe(res => {
      if (res['success']) {
        this.regions = res['regions']
      }

      this.find('')
    });
  }

  /*
  config(fn) {
    this._bannersService.showConfig(this.local).subscribe(res => {
      if (res['success']) {
        let config = res['config']
        this.banner_tipo.setValue(config['tipo'])
        this.banner_intervalo.setValue(config['intervalo'])
        this.banner_colunas.setValue(config['colunas'])
      } else {
        this.banner_tipo.setValue('P')
      }
      if (fn){
        this.find()
      } else {
        this.loadingBanner = false
      }
    });
  }
  */

  onSelectAll(): void {
    this.canDelete = false
    if (this.allSelected) {
      this.canDelete = true
    }
    for(let i in this.banners) {
      this.banners[i]['selected'] = this.allSelected
    }
  }

  onSelect(): void {
    let hasOne = false
    this.allSelected = true
    for(let i in this.banners) {
      if (this.banners[i]['selected']) {
        this.canDelete = true
        hasOne = true
      } else {
        this.allSelected = false
      }
    }
    if (!hasOne) this.canDelete = false
  }

  find(local) {
    this._bannersService.list(local).subscribe(res => {
      if (res.success) {
        this.banners = res.banners
      }
      this.loadingBanner = false
    })
  }

  onFilter() {
    this.loadingBanner = true
    this.find(this.local);
  }

  onClearRegion() {
    this.local = ''
    this.allSelected = false
    this.canDelete = false
    this.onFilter()
  }

  createFormControls() {
    this.banner_tipo = new FormControl('P')
    this.banner_intervalo = new FormControl(3)
    this.banner_colunas = new FormControl(1)
  }

  createForm() {
    this.bannerFrm = new FormGroup({
      banner_tipo: this.banner_tipo,
      banner_intervalo: this.banner_intervalo,
      banner_colunas: this.banner_colunas
    })
  }

  onChangeDetail() {
    this.changed = true
  }

  onCancel() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loadingBanner = true
        // this.config(false)
      }
    })
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.banners, event.previousIndex, event.currentIndex);

    let ordem = []
    let n = 1
    for(let i in this.banners) {
      ordem.push({
        idbanner: this.banners[i].idbanner,
        ordem: n
      })
      this.banners[i].posicao = n
      ++n
    }
    this._bannersService.patchOrdem({ordem}).subscribe(res=>{})
  }

  getDayWeek(number) {
    switch(number) {
      case 2:
        return 'Mostra em todas as Segundas-feiras';
      case 3:
        return 'Mostra em todas as Terças-feiras';
      case 4:
        return 'Mostra em todas as Quartas-feiras';
      case 5:
        return 'Mostra em todas as Quintas-feiras';
      case 6:
        return 'Mostra em todas as Sextas-feiras';
      case 7:
        return 'Mostra em todas os Sábados';
      case 1:
        return 'Mostra em todas os Domingos';
    }
  }

  saveError() {
    Swal.fire("Ops!", "Ocorreu um erro ao tentar salvar.", "error")
  }

  saveComplete() {
    Swal.fire("Salvo!", "A configuração do banner foi salvo", "success")
  }

  saving() {
    Swal.fire({
      title: "Salvando...",
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false
    });
  }

  onSubmit() {

    let data = {
      local: this.local,
      tipo: this.banner_tipo.value,
      intervalo: this.banner_intervalo.value,
      colunas: this.banner_colunas.value
    }

    this.saving()

    this._bannersService.storeConfig(data).subscribe(res => {
      if (res['success']) {
          this.saveComplete()

          this.changed = false
      } else {
        this.saveError()
      }
    })
  }

  deleteError() {
    Swal.fire("Ops!", "Ocorreu um erro ao tentar apagar!", "error")
  }

  deleteComplete() {
    let title = 'O banner foi apagado!'
    let arr = []
    for(let i in this.banners) {
      if (this.banners[i]['selected']) {
        arr.push(this.banners[i]['idbanner'])
      }
    }
    if (arr.length > 1) {
      title = 'Os banners foram apagados!'
    }

    Swal.fire("Salvo!", title, "success")

    this.canDelete = false
    this.find('')
  }

  deleting() {
    Swal.fire({
      title: "Apagando...",
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false
    });
  }

  onDeleteBanner() {
    let title = 'Você deseja apagar o banner selecionado? '
    let arr = []
    let arrDescriptions = []
    for(let i in this.banners) {
      if (this.banners[i]['selected']) {
        arr.push(this.banners[i]['idbanner'])
        arrDescriptions.push(this.banners[i]['titulo'])
      }
    }
    if (arr.length > 1) {
      title = 'Você deseja apagar os banners selecionados? '
    }
    Swal.fire({
      title: title+arrDescriptions.join(', '),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        let ids = arr.join(',')
        if (ids != '') {
          this.deleting()

          this._bannersService.delete(arr.join(','), this.local).subscribe(res => {
            if (res.success) {
              this.deleteComplete()
            } else {
              this.deleteError()
            }
          })
        }
      }
    })
  }

}
